import {
  ConfigurationFormType,
  ConfigurationPageTable,
  ConfigurationPageType,
  ConfigurationTableFilterType,
} from "../interfaces";
import { SURQUAL_COUNTRY_PAGE } from "./SURQUAL_COUNTRY";

export const MAPPING_COUNTRY_PAGE: ConfigurationPageTable = {
  type: ConfigurationPageType.TABLE,
  label: "COUNTRY",
  menuLabel: "COUNTRY",
  pageLabel: "COUNTRY_TITLE_MAPPING",
  name: "mapping_country",
  path: "countries",
  description: "CONF_DESC_MAPPING_COUNTRY",
  model: {
    entityName: "datafeed",
    label: "COUNTRY",
    path: "/api/mapping/countries",
    bulkPath: "/api/mapping/countries/bulk-updates",
    name: "Country",
    attributes: [
      {
        key: "datafeed",
        order: 1,
        label: "DATA_FEED_CODE",
        visible: true,
      },
      {
        key: "connector",
        order: 2,
        label: "CONNECTOR_CODE",
        visible: true,
      },
      {
        key: "country.short_name",
        order: 3,
        label: "COUNTRY",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/mapping/countries/?is_unmapped=true",
      },
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/mapping/countries/connectors/",
        apiParams: {
          page_size: 100,
          ordering: "connector",
        },
        key: "id",
        labelKey: "id",
        label: "CONNECTOR_CODE",
        lookup: "connector",
        allowEmpty: true,
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/mapping/countries/export" },
    import: { path: "/api/mapping/countries/presign-url" },
  },
  options: {
    formFields: [
      {
        type: ConfigurationFormType.Input,
        label: "DATA_FEED_CODE",
        key: "datafeed",
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/countries/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "country",
        label: "COUNTRY",
        labelKey: "short_name",
        subCreationForm: SURQUAL_COUNTRY_PAGE.tabs[0],
      },
    ],
    copyable: false,
    creatable: false,
    deletable: false,
    editable: true,
    editOptions: [
      {
        key: "datafeed",
        flex: "100%",
        readonly: true,
      },
      {
        key: "country",
        flex: "100%",
      },
    ],
    editSelectedOptions: [
      {
        key: "country",
        flex: "100%",
      },
    ],
  },
};
